module.exports = __webpack_public_path__ + "static/img/banner_product.3537e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_product.png
// module id = wMBp
// module chunks = 15